
import { useEffect } from 'react'
import Select from 'react-select'
import { DepartmentDDLAPI, EmployeeDDLAPI, EmployeeGridDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const EmployeeGridDataDDL = (props) => {
    const { EmployeeID, setEmployeeID, CropNameDashboardData, PopUpField, rowData, Flag, IsPost, M_DesignationID, M_ProjectID, M_ProjectTypeID } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_EmployeeID: EmployeeID?.ID ?? 0,
            M_ProjectTypeID: M_ProjectTypeID,
            M_ProjectID: M_ProjectID,
            M_DesignationID: M_DesignationID,
            Flag: Flag,
            M_UserID: UserID,
            token: token,
        }
        dispatch(EmployeeGridDDLAPI({ data }))
    }, [IsPost, EmployeeID?.ID, M_DesignationID, M_ProjectID, M_ProjectTypeID])

    const { EmpGridDDLData } = useSelector(state => state.EmployeeGridDDLData)

    useEffect(() => {
        handleEmployeeDDL()
    }, [EmpGridDDLData])

    const handleEmployeeDDL = () => {
        // console.log(DeptDDLDataa)
        if (EmpGridDDLData && EmpGridDDLData.table && EmpGridDDLData.table.length > 0) {
            let list = EmpGridDDLData.table.map((item, index) => ({
                value: item.m_EmployeeID,
                label: item.employeeName,
            }))

            // setEmployeeID({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setEmployeeID({ ...EmployeeID, DDL: list })
        }
        else {
            setEmployeeID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block " htmlFor="NameofEmployee"><b>Employee {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={150}
                value={{ value: EmployeeID.ID, label: EmployeeID.Label }}
                onChange={(e) => {
                    e ?
                        setEmployeeID({ ...EmployeeID, ID: e.value, Label: e.label })
                        :
                        setEmployeeID({ ...EmployeeID, ID: 0, Label: "Select..." })

                }}
                options={EmployeeID.DDL}
            />
        </div>
    )
}